/* eslint-disable import/no-named-as-default-member */
import create from 'zustand';
import academyApi from 'lib/api/academy';

interface ITokenStore {
  token: any;
  isLoading: boolean;
  createToken: () => void;
}

const tokenStore = create<ITokenStore>((set) => ({
  token: null,
  isLoading: false,
  createToken: async () => {
    try {
      set({ isLoading: true });
      const response = await academyApi.createToken();
      if (!response.data) {
        set({ isLoading: false });
        throw new Error('Error while fetching data');
      }

      const { error, error_type: errorType, data, message } = response.data;

      if (error || errorType) {
        set({ isLoading: false });
        throw new Error(message);
      }

      set({ token: data?.academy_token });
    } catch (err) {
      set({ isLoading: false });
    }
  },
}));

export default tokenStore;
